import styled from 'styled-components'
import { fonts } from '~/styles/fonts'
import { colors } from '~/styles/colors'

export const AmountText = styled.div({
  fontSize: '1.625rem',
  fontWeight: fonts.text.medium,
  color: colors.dark,
})
